
import 'lazysizes';
import 'picturefill'
import 'picturefill/dist/plugins/mutation/pf.mutation.min'

import serialize from 'form-serialize'



class PaymentForm {
	constructor() {

		this.stripe
		this.elements
		this.card


		this.form = document.querySelector('.activism-covertion-form__form');
		this.submitButton = document.querySelector('.activism-covertion-form__form button[type="submit"]');
		this.cardContainer = document.querySelector('.card-element')
		this.errorContainer = document.querySelector('.stripe-error');

		this.createSubscription = this.createSubscription.bind(this);
		this.handlePaymentForm = this.handlePaymentForm.bind(this);
		this.sendConfMail = this.sendConfMail.bind(this);
		this.initStripe = this.initStripe.bind(this);

		if ( this.form ) {
			this.initStripe()
		}
		
	}

	sendConfMail( data, redirect ) {
		fetch('/actions/reklima/stripe/send-confirmation-email', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		}).then(res => res.json())
			.then(result => {
				window.location = redirect
			})
	}


	createSubscription( result, values ) {

		const data = {
			[window.csrfTokenName]: window.csrfTokenValue,
			'email': values.email,
			'token': result.token.id,
			'product': values.product,
			'name': `${values.firstName} ${values.lastName}`,
			'address': {
				'line1': values.address,
				'city': values.city,
				'country': 'no',
				'postal_code': values.zip,
			},
			'phone': values.phone,
		}
		
		this.submitButton.innerHTML = 'Oppretter'

		return fetch('/actions/reklima/stripe/create-subscription',{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		})

	}


	handlePaymentForm( event ) {

		event.preventDefault()


		const originalButtonText = this.submitButton.innerHTML
		this.submitButton.setAttribute('disabled', true)
		this.submitButton.innerHTML = 'Behandler'

		const values = serialize(event.target, { hash: true });

		let userDetails = {
			'name': `${values.firstName} ${values.lastName}`,
			'address_line1': values.address1,
			'address_city': values.city,
			'address_zip': values.zip,
			'address_country': 'no',
		}

		this.stripe.createToken(this.card, userDetails)
			.then( result => this.createSubscription( result, values ) )
			.then( result => result.json() )
			.then( result => {

				const emailData = {
					[window.csrfTokenName]: window.csrfTokenValue,
					'email': values.email,
					'firstName': values.firstName,
					'product': values.product,
				}

				const redirect = `/kvittering-aktivist-personlig?pl=${values.product}&fn=${values.firstName}&em=${values.email}`

				if ( result.success === true ) {
					
					this.submitButton.innerHTML = 'Betaling ok'
					this.sendConfMail(emailData, redirect)

				} else if ( result.secret ) {
					
					this.stripe.handleCardPayment(result.secret)
						.then( res => {
							if ( res.error ) {
							
								this.errorContainer.innerHTML = res.error.message

								this.submitButton.removeAttribute('disabled')
								this.submitButton.innerHTML = originalButtonText
							
							} else {

								this.submitButton.innerHTML = 'Betaling ok'
								this.sendConfMail(emailData, redirect)

							}
						})

				} else if ( result.success === false ) {

					this.errorContainer.innerHTML = result.message

					this.submitButton.removeAttribute('disabled')
					this.submitButton.innerHTML = originalButtonText

				}
			})

	}



    initStripe() {

		if ( typeof Stripe === "undefined" ) {
			setTimeout(this.initStripe, 10);
			return;
		}

		const style = {
			base: {
				fontSize: window.innerWidth > 640 ? '22px' : '16px',
				color: '#412213',
				'::placeholder': {
					'color': '#936A58',
				}
			},
		};

		this.stripe = Stripe(window.stripePk)
		this.elements = this.stripe.elements({locale: 'no'})
		this.card = this.elements.create('card',{
			hidePostalCode: true,
			style: style,
		})

		this.card.mount(this.cardContainer)
		this.form.addEventListener("submit", event => { this.handlePaymentForm(event) })

	}
}



class Reklima {
	constructor() {
		
        this.siteHeader = document.querySelector('.site-header')
		this.toggleMenuButton = document.querySelector('.site-header__toggle-menu-button')
		this.mobileMenuContainer = document.querySelector('.site-header__mobile-navigation')
		this.prevScrollPosition = 0;

		this.scrollHandler = this.scrollHandler.bind(this);
		this.init();

	}

	scrollHandler() {

        let newPosition = window.scrollY,
            offset = 50;

        if( newPosition > offset ) {
            this.siteHeader.classList.add('site-header--solid');
            if ( newPosition > this.prevScrollPosition+25 ) {
                this.siteHeader.classList.add('site-header--hidden');
            } 
            if ( newPosition < this.prevScrollPosition-25 ) {
                this.siteHeader.classList.remove('site-header--hidden');
            }
        } else {
            this.siteHeader.classList.remove('site-header--solid','site-header--hidden');
        }
        this.prevScrollPosition = newPosition;

    }

	




	init() {
        
        document.addEventListener('scroll', this.scrollHandler);
		this.scrollHandler();
		
		const paymentForm = new PaymentForm()

        this.toggleMenuButton.addEventListener('click', e => {

            if ( document.body.classList.contains('menu-is-open') ) {
				this.toggleMenuButton.setAttribute('aria-expanded', false);
                document.body.classList.remove('menu-is-open')
            } else {
				this.toggleMenuButton.setAttribute('aria-expanded', true);
                document.body.classList.add('menu-is-open')
            }

        })

	}

}
const site = new Reklima();
